module.exports = __webpack_public_path__ + "static/media/7.ce8bc9e9.png";